:host {
  display: block;
  max-width: 100%;
  background: var(--white-layout-301-level-0-elevation);
}

.wrapper {
  display: block;
  padding-left: calc(var(--spacer) * 3);

  &.collapsed {
    padding: 0;

    .collapsed-container {
      display: block;
      width: 32px;
      height: 100%;
      cursor: pointer;

      &:hover {
        ::part(button) {
          background-color: var(--chart-050-hover);
        }
      }
    }
    .panel-container {
      display: none;
    }
  }

  .collapsed-container {
    display: none;
  }

  .title {
    color: var(--chart-302-icon-buttons-titles);
  }
}

gz-single-select {
  --dropdown-min-width: 100%;
  --dropdown-list-width: 100%;
}
